import { RouterModule, Routes } from "@angular/router";

import { HomeComponent } from './pages/home/home.component';

const appRoutes: Routes = [
  { path: 'inicio', component: HomeComponent },
  { path: '**', redirectTo: 'inicio', pathMatch: 'full' },
  { path: '', redirectTo: 'inicio', pathMatch: 'full' }
]

export const APP_ROUTES = RouterModule.forRoot(appRoutes, {useHash: true});